import { Team } from '@agently/types';
import { createSuspenseQuery } from 'react-query-kit';

import { api } from './client';

export const useGetTeam = createSuspenseQuery({
  fetcher: async () => {
    const { data } = await api.get<Team>('/team');
    return data;
  },
  queryKey: ['team'],
});
